import { makeStyles } from '@material-ui/core';

export const useProgressStyles = makeStyles((theme) => ({
  caption: {
    fontFamily: 'MuseoSans',
    fontWeight: 300,
  },
}));
